/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDateOverviewQueryResponse, GetStatsByDateOverviewQueryParams, GetStatsByDateOverview400 } from '../entities/GetStatsByDateOverview'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetStatsByDateOverviewUrl() {
  return `/stats/by-date/overview` as const
}

/**
 * @description Get stats by date overview
 * @summary Get stats by date overview
 * {@link /stats/by-date/overview}
 */
export async function getStatsByDateOverview(params?: GetStatsByDateOverviewQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetStatsByDateOverviewQueryResponse, ResponseErrorConfig<GetStatsByDateOverview400>, unknown>({
    method: 'GET',
    url: getGetStatsByDateOverviewUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}